"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PulseNotificationsTab = exports.mapStateToProps = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _actions = require("../../store/actions/actions");

var _NotificationReducer = require("../../store/reducers/NotificationReducer");

var _PulseNotificationMessageWrapper = _interopRequireDefault(require("../message/PulseNotificationMessageWrapper"));

var _IllustratedMessage = _interopRequireDefault(require("@react/react-spectrum/IllustratedMessage"));

var _NoContent = _interopRequireDefault(require("../../resources/NoContent"));

var _adobeIntlReact = _interopRequireWildcard(require("@adobe/adobe-intl-react"));

var localizationStrings = _interopRequireWildcard(require("./__localization__/PulseNotificationsTab"));

var types = _interopRequireWildcard(require("../../store/actions/actionTypes"));

var _Wait = _interopRequireDefault(require("@react/react-spectrum/Wait"));

var _SettingsService = _interopRequireDefault(require("../../service/SettingsService"));

require("./PulseNotificationsTab.scss");

var _PulseUtil = _interopRequireDefault(require("../../util/PulseUtil"));

var _ViewAllNotificationsTab = require("./../viewall/ViewAllNotificationsTab");

var _metrics = _interopRequireDefault(require("../../custom-hooks/metrics"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var NewSectionHeader = (0, _react.forwardRef)(function (props, ref) {
  var maxDigits = 1,
      TEN = 10,
      maxValue = Math.pow(TEN, maxDigits) - 1;
  var newCount = props.newCount > maxValue ? "".concat(maxValue, "+") : "".concat(props.newCount);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("li", {
    className: "pulse-notification-section-header fixed-section-header",
    key: "new",
    ref: ref
  }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
    defaultMessage: props.sectionHeader,
    description: "".concat(props.sectionHeader, " Header"),
    messageId: props.sectionHeader
  }), props.sectionHeader !== 'EARLIER' && " (".concat(newCount, ")")), _react.default.createElement("li", {
    className: "dummy-section-header"
  }));
});
var EarlierSectionHeader = (0, _react.forwardRef)(function (props, ref) {
  return _react.default.createElement("li", {
    className: "pulse-notification-section-header earlier-section",
    key: "earlier",
    ref: ref
  }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
    defaultMessage: "EARLIER",
    description: "Earlier Header",
    messageId: "Earlier"
  }));
});

var NotificationsSection = function NotificationsSection(props) {
  var notifications = props.notifications,
      locale = props.locale,
      serverTimeStamp = props.serverTimeStamp,
      clientTimeStamp = props.clientTimeStamp;

  if (notifications.length === 0) {
    return null;
  }

  return _react.default.createElement(_react.default.Fragment, null, notifications.map(function (notifications) {
    return _react.default.createElement("li", {
      key: notifications.id
    }, _react.default.createElement(_PulseNotificationMessageWrapper.default, {
      clientTimeStamp: clientTimeStamp,
      isFloatingAlert: false,
      isReminder: false,
      locale: locale,
      pulseMessageObject: notifications,
      renderCrossButton: false,
      serverTimeStamp: serverTimeStamp
    }));
  }));
};

var NewNotificationsButton = function NewNotificationsButton(props) {
  var count = props.count,
      serverTimeStamp = props.serverTimeStamp,
      clientTimeStamp = props.clientTimeStamp,
      dispatchToSetFlyoutLastOpenTimeStamp = props.dispatchToSetFlyoutLastOpenTimeStamp;
  return _react.default.createElement("li", null, _react.default.createElement(_Button.default, {
    className: "pulse-button-new-notifications",
    onClick: function onClick() {
      var serverTime = _PulseUtil.default.getServerTimeFromNow(serverTimeStamp, clientTimeStamp);

      dispatchToSetFlyoutLastOpenTimeStamp(serverTime);
    },
    variant: "cta"
  }, count > 1 ? _react.default.createElement(_adobeIntlReact.FormattedMessage, {
    defaultMessage: "{newCount} new notifications",
    description: "new notifications (Multiple)",
    messageId: "newNotifications",
    values: {
      newCount: count
    }
  }) : _react.default.createElement(_adobeIntlReact.FormattedMessage, {
    defaultMessage: "{newCount} new notification",
    description: "new notification (Single)",
    messageId: "newNotification",
    values: {
      newCount: count
    }
  })));
};

var NotificationsComponents = function NotificationsComponents(props) {
  var hasEndReached = props.hasEndReached,
      previousPageTimestamp = props.previousPageTimestamp,
      lastOpenTimestamp = props.lastOpenTimestamp,
      isFlyoutVisible = props.isFlyoutVisible,
      newNotifications = props.newNotifications,
      earlierNotifications = props.earlierNotifications,
      locale = props.locale,
      serverTimeStamp = props.serverTimeStamp,
      clientTimeStamp = props.clientTimeStamp,
      metrics = props.metrics,
      dispatchToFetchTimeline = props.dispatchToFetchTimeline,
      dispatchToSetFlyoutLastOpenTimeStamp = props.dispatchToSetFlyoutLastOpenTimeStamp;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loadMore = _useState2[0],
      setLoadMore = _useState2[1];

  var _useState3 = (0, _react.useState)('NEW'),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      sectionHeader = _useState4[0],
      setSectionHeader = _useState4[1];

  var earlierSection = (0, _react.useRef)(null);
  var newSection = (0, _react.useRef)(null);

  var handleScroll =
  /*#__PURE__*/
  function () {
    var _ref = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee(e) {
      var topOffset, earlierPosition, newPosition, bottom;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (e.target) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              topOffset = e.target.scrollTop;
              earlierPosition = earlierSection && earlierSection.current && earlierSection.current.offsetTop;
              newPosition = newSection && newSection.current && newSection.current.offsetTop - newSection.current.clientHeight * 2.5;

              if (_PulseUtil.default.isEarlierSectionHeader(topOffset, earlierPosition, newPosition)) {
                setSectionHeader('EARLIER');
              } else {
                setSectionHeader('NEW');
              }

              bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;

              if (!(bottom && !hasEndReached)) {
                _context.next = 14;
                break;
              }

              if (loadMore) {
                _context.next = 14;
                break;
              }

              metrics.event('flyout.loadMoreNotifications.onScroll', {
                region: window.config && window.config.region
              });
              setLoadMore(true);
              _context.next = 13;
              return dispatchToFetchTimeline({
                to: previousPageTimestamp
              });

            case 13:
              setLoadMore(false);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleScroll(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var components = [];

  if (!isFlyoutVisible) {
    if (newNotifications.length > 0) {
      components.push(_react.default.createElement(NewSectionHeader, {
        key: 1,
        newCount: newNotifications.length,
        ref: newSection,
        sectionHeader: sectionHeader
      }));
      components.push(_react.default.createElement(NotificationsSection, {
        clientTimeStamp: clientTimeStamp,
        key: 2,
        locale: locale,
        notifications: newNotifications,
        serverTimeStamp: serverTimeStamp
      }));
      earlierNotifications.length > 0 && components.push(_react.default.createElement(EarlierSectionHeader, {
        key: 3,
        ref: earlierSection
      }));
    }

    components.push(_react.default.createElement(NotificationsSection, {
      clientTimeStamp: clientTimeStamp,
      key: 4,
      locale: locale,
      notifications: earlierNotifications,
      serverTimeStamp: serverTimeStamp
    }));
  } else {
    var unOpenedNotifications = newNotifications.filter(function (notif) {
      return notif.sortedTimestamp < lastOpenTimestamp;
    });
    var justArrivedNotificationCount = newNotifications.length - unOpenedNotifications.length;

    if (newNotifications.length > 0) {
      //only add notifications that got received before the lastOpenTimestamp
      if (unOpenedNotifications.length > 0) {
        components.push(_react.default.createElement(NewSectionHeader, {
          key: 5,
          newCount: unOpenedNotifications.length,
          ref: newSection,
          sectionHeader: sectionHeader
        }));
        components.push(_react.default.createElement(NotificationsSection, {
          clientTimeStamp: clientTimeStamp,
          key: 6,
          locale: locale,
          notifications: unOpenedNotifications,
          serverTimeStamp: serverTimeStamp
        }));
        earlierNotifications.length > 0 && components.push(_react.default.createElement(EarlierSectionHeader, {
          key: 7,
          ref: earlierSection
        }));
      }
    }

    components.push(_react.default.createElement(NotificationsSection, {
      clientTimeStamp: clientTimeStamp,
      key: 8,
      locale: locale,
      notifications: earlierNotifications,
      serverTimeStamp: serverTimeStamp
    }));

    if (justArrivedNotificationCount > 0) {
      components.push(_react.default.createElement(NewNotificationsButton, {
        clientTimeStamp: clientTimeStamp,
        count: justArrivedNotificationCount,
        dispatchToSetFlyoutLastOpenTimeStamp: dispatchToSetFlyoutLastOpenTimeStamp,
        key: 9,
        serverTimeStamp: serverTimeStamp
      }));
    }

    if (loadMore) {
      components.push(_react.default.createElement("li", {
        className: "pulse-notifications-tab-load-more-area",
        key: 10
      }, _react.default.createElement(_Wait.default, null)));
    }
  }

  return _react.default.createElement("div", {
    className: "pulse-notifications-tab pulse-notifications-tab-container"
  }, _react.default.createElement("ul", {
    className: "pulse-notifications-tab-list",
    onScroll: handleScroll
  }, components));
};

var NotificationsPane = function NotificationsPane(props) {
  var notificationsById = props.notificationsById,
      newNotifications = props.newNotifications,
      earlierNotifications = props.earlierNotifications;

  if (!notificationsById) {
    return _react.default.createElement(_ViewAllNotificationsTab.LoadingSpinner, {
      className: "pulse-no-notifications-message"
    });
  }

  if (newNotifications.length === 0 && earlierNotifications.length === 0) {
    /**
     * TODO: Need to check if we can show the same message from view all page.
     */
    return _react.default.createElement(_IllustratedMessage.default, {
      className: "pulse-no-notifications-message",
      description: _react.default.createElement(_adobeIntlReact.FormattedMessage, {
        defaultMessage: "You will receive important information about our products, your collaboration with fellow users, and other relevant updates",
        description: "No Notifications",
        messageId: "noNotifications"
      }),
      heading: _react.default.createElement(_adobeIntlReact.FormattedMessage, {
        defaultMessage: "Your Notifications will appear here",
        description: "No Notifications title",
        messageId: "noNotificationsTitle"
      }),
      illustration: _react.default.createElement(_NoContent.default, null)
    });
  }

  return _react.default.createElement(NotificationsComponents, props);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasEndReached: (0, _NotificationReducer.hasTimelineEndReached)(state),
    previousPageTimestamp: (0, _NotificationReducer.getPreviousPageTimestamp)(state),
    lastOpenTimestamp: (0, _NotificationReducer.getLastOpenTimestamp)(state),
    isFlyoutVisible: (0, _NotificationReducer.isFlyoutOpen)(state),
    serverTimeStamp: (0, _NotificationReducer.getServerTimestamp)(state),
    clientTimeStamp: (0, _NotificationReducer.getClientTimestamp)(state),
    notificationsById: (0, _NotificationReducer.getNotificationsById)(state),
    newNotifications: (0, _NotificationReducer.getNewNotifications)(state).map(function (id) {
      return (0, _NotificationReducer.getNotificationById)(state, id);
    }),
    earlierNotifications: (0, _NotificationReducer.getEarlierNotifications)(state).map(function (id) {
      return (0, _NotificationReducer.getNotificationById)(state, id);
    })
  };
};

exports.mapStateToProps = mapStateToProps;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dispatchToUpdateLastNotificationsSeenTimeStamp: function dispatchToUpdateLastNotificationsSeenTimeStamp(tStamp) {
      dispatch({
        type: types.SET_LAST_NOTIFICATION_SEEN_TIMESTAMP,
        payload: tStamp
      });
    },
    dispatchToUpdateLastUserClickTimeStamp: function dispatchToUpdateLastUserClickTimeStamp(tStamp) {
      dispatch({
        type: types.SET_LAST_USER_CLICK_TIMESTAMP,
        payload: tStamp
      });
    },
    dispatchToFetchTimeline: function () {
      var _dispatchToFetchTimeline = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(payload) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dispatch((0, _actions.fetchTimeline)(payload));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function dispatchToFetchTimeline(_x2) {
        return _dispatchToFetchTimeline.apply(this, arguments);
      }

      return dispatchToFetchTimeline;
    }(),
    dispatchToSetFlyoutLastOpenTimeStamp: function dispatchToSetFlyoutLastOpenTimeStamp(serverTime) {
      dispatch({
        type: types.SET_FLYOUT_LAST_OPEN_TIMESTAMP,
        payload: serverTime
      });
    }
  };
};

var PulseNotificationsTab = function PulseNotificationsTab(props) {
  var locale = props.locale,
      clientTimeStamp = props.clientTimeStamp,
      serverTimeStamp = props.serverTimeStamp,
      dispatchToUpdateLastUserClickTimeStamp = props.dispatchToUpdateLastUserClickTimeStamp,
      dispatchToUpdateLastNotificationsSeenTimeStamp = props.dispatchToUpdateLastNotificationsSeenTimeStamp;
  var metrics = (0, _metrics.default)('exc.pulse.components.tabs.PulseNotificationsTab');
  (0, _react.useEffect)(function () {
    return (
      /*#__PURE__*/
      (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3() {
        var serverTime;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                serverTime = _PulseUtil.default.getServerTimeFromNow(serverTimeStamp, clientTimeStamp);
                dispatchToUpdateLastUserClickTimeStamp(serverTime);
                dispatchToUpdateLastNotificationsSeenTimeStamp(serverTime);
                _context3.next = 5;
                return _SettingsService.default.updateUserSettings({
                  lastClickTimestamp: serverTime,
                  lastNotificationSeenTimestamp: serverTime
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))
    );
  }, []);
  return _react.default.createElement(_adobeIntlReact.default, {
    locale: locale,
    localeData: localizationStrings
  }, _react.default.createElement("div", {
    className: "pulse-notifications-tab pulse-notifications-tab-container"
  }, _react.default.createElement(NotificationsPane, (0, _extends2.default)({
    metrics: metrics
  }, props))));
};

exports.PulseNotificationsTab = PulseNotificationsTab;

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PulseNotificationsTab);

exports.default = _default;